var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okText: this.$store.getters.language["common.okButton"],
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        "ok-disabled": true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: {
        ok: _vm.handleOk,
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _c("my-finished-form", {
        ref: "realForm",
        attrs: {
          disabled: _vm.disableSubmit,
          innerFullscreen: _vm.innerFullscreen
        },
        on: { ok: _vm.submitCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }